module.exports = __webpack_public_path__ + "img/emoji_23.830dd017.png";